// extracted by mini-css-extract-plugin
module.exports = {"taxes":"styles_taxes__mPn_c","tax":"styles_tax__St212","iconWrapper":"styles_iconWrapper___Pw_9","icon":"styles_icon__vIuzs"};